var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.975 1.033c1.569 1.176 3.66 4.834 3.66 9.147 0 2.152-1.531 4.194-3.13 6.327-1.897 2.531-3.89 5.19-3.535 8.31.19 2.215 1.116 3.88 1.693 4.917.615 1.104.835 1.5-.648 1.095-5.097-1.44-10.062-9.15-4.705-16.075.504-.712 1.109-1.376 1.744-2.074 2.166-2.379 4.69-5.151 4.79-11.517 0-.261.131-.13.131-.13zm3.66 17.38c1.437-2.09 2.482-4.312 2.744-5.358 1.175.916 4.312 4.052 3.789 9.018-.358 4.632-3.952 6.889-4.703 7.36-.075.047-.122.077-.134.088-1.531.722-1.572 1.443-1.75 1.479-.08.015-.187-.108-.471-.433-1.568-1.83-4.313-5.227.523-12.154z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHt);
export default __webpack_public_path__ + "static/media/HT.66adcd5abc30e79dea76f63bd8b56853.svg";
export { ForwardRef as ReactComponent };